import { queryOptions } from '@tanstack/react-query'
import { apiGet } from './client'

/**
 * ADM -> Discovery, calea noua. Perechea veche, din
 * `application/controllers/Adm.php`:
 *
 *   dashboard + getDashboardCounters + activeRuns + recentCis
 *   + unclassified + credentialsHealth   -> GET /adm/dashboard
 *
 * Calea NU poarta `/api/v2`: il pune `apiGet`.
 *
 * SASE CERERI IN PORTAL, UNA AICI. Acolo fiecare panou era o pagina randata pe
 * server si isi citea SINGUR bara de filtre din cerere - deci doua panouri
 * puteau raspunde cu ferestre de timp diferite si nimic n-o spunea. Aici bara e
 * citita o data, pe server (`AdmFilters`), si tot tabloul vine dintr-un raspuns.
 */

export interface AdmView {
  url: string
  icon: string
  label: string
  note: string
}

export interface AdmCounters {
  runsActive: number
  ciTotal: number
  ciNew: number
  ciStale: number
  errorsActive: number
  coveragePct: number
  correlationPct: number
  /** Tintele din cerinta 73 - `DiscoveryCoverage::TARGET_*`. */
  coverageTarget: number
  correlationTarget: number
  /** Ziua rezumatului din care vin procentele; gol cand n-a rulat inca. */
  coverageDay: string
  credentialsFailed: number
  pendingWaiting: number
  staleDays: number
  windowDays: number
}

export interface AdmRun {
  id: number
  runType: number
  runTypeLabel: string
  state: number
  stateLabel: string
  startedAt: string
  targetsTotal: number
  targetsResponded: number
  /** `null` = scanarea e la inceput si n-are inca ce raporta. */
  percent: number | null
  ciCreated: number
  ciUpdated: number
  errorsCount: number
  companyName: string
  relayName: string
}

export interface AdmCi {
  id: number
  name: string
  className: string
  companyName: string
  firstSeen: string
  criticality: number
  criticalityLabel: string
}

export interface AdmPendingRow {
  id: number
  deviceName: string
  ip: string
  companyName: string
  matchedName: string
  firstSaw: string
}

export interface AdmCredential {
  id: number
  name: string
  typeLabel: string
  username: string
  failures24h: number
  lastOk: string
  expired: boolean
  state: 'expired' | 'failing' | 'working' | 'untested'
}

export interface AdmRelay {
  id: number
  name: string
  companyName: string
}

export interface AdmDashboard {
  pageTitle: string
  pageHeader: string
  breadcrumbs: string[]
  windows: number[]
  filters: { days: number; company_id: number; relay_device_id: number; run_type: number; state: number }
  /** Cele doua procente se arata numai dupa pilotul din cerinta 73. */
  showCoverage: boolean
  /** DEJA filtrate pe server - pe drept si pe "s-a mutat deja". */
  views: AdmView[]
  relays: AdmRelay[]
  runTypes: { value: string; label: string }[]
  counters: AdmCounters
  activeRuns: AdmRun[]
  recentCis: AdmCi[]
  pending: AdmPendingRow[]
  pendingTotal: number
  credentials: AdmCredential[]
  credentialsTotal: number
  canRunScans: boolean
}

export function admDashboardQuery(days: number, relayDeviceId: number) {
  const params = new URLSearchParams({ days: String(days), relay_device_id: String(relayDeviceId) })

  return queryOptions({
    queryKey: ['adm', 'dashboard', days, relayDeviceId],
    queryFn: () => apiGet<AdmDashboard>(`/adm/dashboard?${params.toString()}`),
  })
}
